import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const businessDetailSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    postBusinessDetail: builder.mutation({
      query: (data) => ({
        url: "supplier-save-public-information",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
  }),
});

export const { usePostBusinessDetailMutation } = businessDetailSlice;
